import shruggingFemale from './shrugging-female.png';

const imagePath = {
	'shrugging-female': shruggingFemale,
};

export default imagePath;
